import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static values = {
    markClickedUrl: String
  }

  async markAsClicked(event) {
    const deliveryId = event.currentTarget.dataset.deliveryId
    if (!deliveryId) return

    // Let modified clicks open a new tab without blocking navigation.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (event.button !== 0) return

    event.preventDefault()

    const url = event.currentTarget.href

    try {
      await post(this.markClickedUrlValue, {
        body: JSON.stringify({ delivery_id: deliveryId }),
        contentType: "application/json"
      })
    } catch (error) {
      console.error("Failed to mark notification as clicked:", error)
    } finally {
      window.location.assign(url)
    }
  }
}
